import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createVersionReview } from "services";

import { LIST_VERSION_REVIEWS } from "consts";

export const useCreateVersionReview = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createVersionReview,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_VERSION_REVIEWS] });
    },
  });
};
